import { getScaledFont } from '@wix/thunderbolt-becky-root'
import type { RadioGroupDefinition, RadioGroupCSSVars } from './RadioGroup'
import { getRequiredIndicationDisplay } from '../../core/carmi/InputUtils/InputUtils'
import { withCompInfo } from '@wix/editor-elements-integrations'
import type { RadioButtonData } from '../../core/schemas/RadioButton/RadioButton'

export const css = withCompInfo<RadioGroupCSSVars, RadioGroupDefinition>()(
	[
		'compLayout',
		'hasResponsiveLayout',
		'styleProperties',
		'siteFonts',
		'isMobileView',
		'compProps',
		// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
		'isOneDocMigrated',
	],
	// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
	({ compLayout, hasResponsiveLayout, styleProperties, siteFonts, isMobileView, compProps, isOneDocMigrated }) => {
		const { alignment, buttonsMargin, buttonSize, spacing, labelMargin = 0 } = compProps
		const isRightAlignment = alignment === 'right'
		const labelMarginPx = isRightAlignment ? `auto ${spacing + 1}px auto auto` : `auto auto auto ${spacing + 1}px`
		const isHorizontalAlignment = compProps.layout === 'horizontal'

		const directionProps = isHorizontalAlignment
			? {
				'--itemsFlexDirection': 'row',
				'--itemsMargin': `0 ${buttonsMargin}px 0 0`,
				'--itemsFlex': '1',
			}
			: {
				'--itemsFlexDirection': 'column',
				'--itemsMargin': `0 0 ${buttonsMargin}px 0`,
				'--itemsWidth': '100%',
			}

		const compInfo = { compLayout, styleProperties, siteFonts, isMobileView }
		return {
			'--fnt2': getScaledFont(compInfo, 'fnt2', isOneDocMigrated, compProps.labelMobileFontSize),
			'--fnt': getScaledFont(compInfo, 'fnt', isOneDocMigrated, compProps.inputMobileFontSize),
			'--buttonSize': `${buttonSize}px`,
			'--dir': isRightAlignment ? 'rtl' : 'ltr',
			'--flexDirection': isRightAlignment ? 'row-reverse' : 'reverse',
			'--labelMargin': labelMarginPx,
			'--groupLabelMargin': `0 0 ${labelMargin}px 0`,
			'--textAlign': alignment,
			'--requiredIndicationDisplay': getRequiredIndicationDisplay(styleProperties),
			...directionProps,
			...(!hasResponsiveLayout && {
				height: 'auto',
			}),
		}
	}
)

export const props = withCompInfo<any, RadioGroupDefinition>()(['compProps', 'compData'], ({ compProps, compData }) => {
	const { options = [], label, value = '' } = compData as any
	const { required, isDisabled } = compProps as any

	const parsedOptions = (options as Array<RadioButtonData>)?.map((checkboxData) => {
		return {
			label: (checkboxData as any).label,
			value: (checkboxData as any).value,
			required,
			isDisabled,
		}
	})

	return {
		label,
		value,
		options: parsedOptions,
		required,
		isDisabled,
	}
})
